import React from 'react';
import PropTypes from 'prop-types';
import {Grid, Paper} from "@material-ui/core";
import CurrencyField from "../Fields/CurrencyField";
import TextField from "../Fields/TextField";
import useStyles from "../../styles/styles";
import setDate from '../../utils/setDate';

const LeadPurchaseResultInformation = ({result}) => {
    const classes = useStyles();

    result = result || {}

    return (
        <>
            <Paper className={classes.paper}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={2} lg={3}>
                        <TextField label="Status" value={result.status}/>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <TextField label="Request received at"
                                   value={result.requestReceivedAt && setDate(result.requestReceivedAt)}/>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2} lg={3}>
                        <TextField label="Processing time" value={`${result.processTime} sec`}/>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <TextField label="Process completed at"
                                   value={result.processCompletedAt && setDate(result.processCompletedAt)}/>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2} lg={1}>
                        <CurrencyField label="Billed" value={result.billed}/>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2} lg={1}>
                        <CurrencyField label="Payout" value={result.payout}/>
                    </Grid>
                </Grid>
            </Paper>
        </>
    )
};

LeadPurchaseResultInformation.propTypes = {
    result: PropTypes.shape({
        id: PropTypes.string,
        /** ISO-8601 datetime string to be passed to javascript's [Date] constructor */
        createdAt: PropTypes.string,
        /** ISO-8601 datetime string to be passed to javascript's [Date] constructor */
        modifiedAt: PropTypes.string,
        status: PropTypes.string,
        /** ISO-8601 datetime string to be passed to javascript's [Date] constructor */
        requestReceivedAt: PropTypes.string.isRequired,
        processTime: PropTypes.number.isRequired,
        /** ISO-8601 datetime string to be passed to javascript's [Date] constructor */
        processCompletedAt: PropTypes.string.isRequired,
        billed: PropTypes.number,
        payout: PropTypes.number,
        redirectUrl: PropTypes.string,
    }),
};

LeadPurchaseResultInformation.defaultProps = {
    result: {},
};

export default LeadPurchaseResultInformation;
